import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../style/Header.css";

const Header = () => {
  const { t, i18n } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
    setMenuOpen(false);
  };

  return (
    <>
      <div className="top-bar">
        <div className="top-bar-left">
          <div className="info-item">
            <span>+49 175 1932947</span>
          </div>

          <div className="info-item">
            <span>autopark.lennestadt@gmail.com</span>
          </div>
        </div>

        <div className="top-bar-right">
          <span>{t("header.workTime")}</span>
        </div>
      </div>

      <nav className="navbar">
        <div className="logo">AutoPark</div>

        <button
          type="button"
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
          <ul className="nav-links">
            <li>
              <NavLink to="/" onClick={() => setMenuOpen(false)}>
                {t("header.home")}
              </NavLink>
            </li>

            <li>
              <NavLink to="/about" onClick={() => setMenuOpen(false)}>
                {t("header.about")}
              </NavLink>
            </li>

            <li>
              <NavLink to="/services" onClick={() => setMenuOpen(false)}>
                {t("header.services")}
              </NavLink>
            </li>

            <li>
              <NavLink to="/contact" onClick={() => setMenuOpen(false)}>
                {t("header.contact")}
              </NavLink>
            </li>

            <li>
              <NavLink to="/cars" onClick={() => setMenuOpen(false)}>
                {t("header.cars")}
              </NavLink>
            </li>
          </ul>

          <div className="language-switcher">
            <button type="button" onClick={() => changeLanguage("en")}>
              EN
            </button>

            <button type="button" onClick={() => changeLanguage("de")}>
              DE
            </button>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;